import React, { useState, useEffect, useCallback } from 'react';
import {
  Modal, ModalBody
} from 'reactstrap';

import Block from './calendar-block';
const Calendar = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [dateModal, setDateModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const toggleModal = (data=null) => {
    setModalData(data);
    setModal(!modal)
  };

  const toggleDateModal = (data=null) => {
    setDateModal(!dateModal)
  };

  const load = useCallback(async() => {
    let loadedData = await fetch('data.json');
    let jsonData = await loadedData.json();
    setData(jsonData);
  },[setData])

  useEffect(()=> {
    if (loading && data.length===0) {
      setLoading(false);
      load();
    }
  },[setLoading, loading, data, load]);

  const updatePositions = useCallback(() => {
    let windowWidth = window.innerWidth;
    let colNum = 3;
    if (windowWidth>550) {
      colNum = 4;
    }
    if (windowWidth>1199) {
      colNum = 5;
    }
    let left = 0;
    let row = 0;
    for (let i=0; i<data.length; i++) {
      let elem = document.getElementById("block-"+i);
      let top = 0;
      if (i%colNum===0) {
        left = 0;
        row = row+1;
      }
      else {
        if (windowWidth>767) {
          left = left + 212;
        }
        else {
          left = left + 162;
        }
      }
      if (row>0) {
        for (let r=0; r<row; r++) {
          top = top + getElemTop(i, r, colNum);
        }
      }
      elem.style.left = left+"px";
      elem.style.top = top+"px";
    }
  },[data])

  const getElemTop = (i, row, colNum) => {
    let top = 0;
    let topElementIndex = i-(colNum*row);
    if (topElementIndex>-1 && topElementIndex!==i) {
      if (topElementIndex===1) {
        topElementIndex = 0;
      }

      let topElement = document.getElementById("block-"+topElementIndex);

      if (topElement!==null) {
        let box = topElement.getBoundingClientRect();
        let height = parseFloat(box.height,10);
        top = height+12;
      }

    }
    return top;
  }

  useEffect(()=> {
    if (!loading && data.length>0) {
      updatePositions();
      setTimeout(()=>{updatePositions()},500);
    }
    window.addEventListener("resize", updatePositions);
    return () => {
      window.removeEventListener("resize", updatePositions);
    }
  },[loading, data, updatePositions]);

  let calendarBlocks = [];
  for (let key in data) {
    let block = data[key];
    calendarBlocks.push(<Block id={"block-"+key} key={key} day={block.day} image={block.image} link={block.link} message={block.message} youtube={block.youtube} toggleModal={toggleModal} toggleDateModal={toggleDateModal}/>);
  }


  let modalImg = [];
  let modalVideo = [];
  let modalLink = [];
  let modalMessage = [];
  if (modalData!==null) {
    if (modalData.image!=="") {
      let src = "./images/fullsize/"+modalData.image;
      modalImg = <img src={src} className="modal-img" alt="" />
    }
    if (modalData.image==="" && modalData.youtube!=="") {
      let youtubeURL = modalData.youtube.replace("https://www.youtube.com/watch?v=", "");
      let iframeStyle = {
        width: "calc(100% + 32px)",
        margin: "0 -16px"
      }
      let iframe = <iframe title="external video" style={iframeStyle} height={315} src={"https://www.youtube.com/embed/"+youtubeURL} frameBorder={0} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>;
      modalVideo = iframe;
    }
    if (modalData.message!=="") {
      modalMessage = <div className="modal-msg" dangerouslySetInnerHTML={{__html: modalData.message}}></div>
    }
    if (typeof modalData.link!=="undefined" && modalData.link.url!=="") {
      if (typeof modalData.link.length!=="undefined") {
        for (let mlkey in modalData.link) {
          let newLink = modalData.link[mlkey];
          let newLinkItem = <div className="text-center inline" key={mlkey}>
            <a className="btn btn-primary btn-lg modal-link" href={newLink.url} target="_blank" rel="noopener noreferrer">{newLink.text}</a>
          </div>
          modalLink.push(newLinkItem);
        }
        modalLink = <div className="text-center">{modalLink}</div>
      }
      else {
        modalLink = <div className="text-center">
          <a className="btn btn-primary btn-lg modal-link" href={modalData.link.url} target="_blank" rel="noopener noreferrer">{modalData.link.text}</a>
        </div>
      }

    }
  }
  let modalHTML = <Modal isOpen={modal} toggle={()=>toggleModal(null)} className="block-modal">
    <button type="button" className="close modal-close" aria-label="Close" onClick={()=>toggleModal(null)}>
      <span aria-hidden="true">×</span>
    </button>
    <ModalBody>
      {modalImg}
      {modalMessage}
      {modalVideo}
      {modalLink}
    </ModalBody>
  </Modal>

  let dateModalHTML = <Modal isOpen={dateModal} toggle={()=>toggleDateModal()} className="modal-dialog-centered" size="sm">
    <button type="button" className="close modal-close" aria-label="Close" onClick={()=>toggleDateModal()}>
      <span aria-hidden="true">×</span>
    </button>
    <ModalBody>
      <p>It's not time yet :)</p>
    </ModalBody>
  </Modal>

  return(
    <div style={{maxWidth: "100%"}}>
      <div className="blocks-row">{calendarBlocks}</div>
      {modalHTML}
      {dateModalHTML}
    </div>
  );
}

export default Calendar;
